import { Skeleton } from '@heroui/react';

import {
  EnvironmentIndicator,
  EnvironmentType
} from '~/components/EnvironmentIndicator';
import {
  getMessageStatus,
  StatusKey
} from '~/scenes/Runtime/scenes/Deployments/utils/deploymentUtils';

export type DeployStatusCellProps = {
  status?: StatusKey;
  environment?: EnvironmentType;
};

export type { StatusKey };

export const DeployStatusCell = ({
  status,
  environment
}: DeployStatusCellProps) => {
  if (!status || !environment) return null;

  const { icon: IconComponent, text } = getMessageStatus({
    deployStatus: status
  });

  return (
    <div className='flex w-[140px] items-center gap-3'>
      <IconComponent className='icon-small' />
      <div className='flex flex-col gap-1'>
        <p>{text}</p>
        <EnvironmentIndicator environment={environment} />
      </div>
    </div>
  );
};

export const DeployStatusCellSkeleton = () => (
  <div className='flex w-[140px] items-center gap-3'>
    <Skeleton className='h-4 w-4 rounded' />
    <div className='flex flex-col gap-1'>
      <Skeleton className='h-4 w-16 rounded' />
      <Skeleton className='h-3 w-20 rounded' />
    </div>
  </div>
);
